'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.modalService = exports.ModalService = void 0;
var tslib_1 = require("tslib");
var modal_constants_1 = require("./modal.constants");
var scroll_1 = require("../scroll");
var magic_messages_1 = require("@gig/magic-messages");
var ModalService = /** @class */ (function () {
    function ModalService() {
        this.idCount = 0;
        this.modals = new Set();
        this.listeners = new Set();
    }
    /**
     * Opens a modal component
     * @param header - If passed, it will be shown in the header slot
     * @param body - Content of the modal, either a string with HTML or an Element
     * @param options - Modal options
     * @param options.size - the width of the modal
     * @param options.dismissible - enable / disable the close button
     * and overlay click to close feature
     * @returns {IModal}
     */
    ModalService.prototype.open = function (header, body, options) {
        if (options === void 0) { options = {}; }
        options = tslib_1.__assign({ dismissible: true, dismissibleBackdrop: true, size: modal_constants_1.ModalSize.DEFAULT }, options);
        var modal = {
            header: header,
            body: this.getBodyNode(body),
            options: options,
            id: this.idCount++,
        };
        this.modals.add(modal);
        this.modalsChanged(modal.id);
        return modal;
    };
    /**
     * Replaces the modal body
     * @param modal
     * @param body
     * @param options
     */
    ModalService.prototype.replace = function (modal, body, options, header) {
        if (options === void 0) { options = null; }
        if (header === void 0) { header = undefined; }
        if (!this.modals.has(modal)) {
            this.open(header || null, body, options || {});
            return;
        }
        modal.header = header !== undefined ? header : modal.header;
        modal.body = this.getBodyNode(body);
        modal.options = options !== null ? options : modal.options;
        this.modalsChanged(modal.id);
    };
    ModalService.prototype.updateOptions = function (modal, options) {
        if (options === void 0) { options = null; }
        modal.options = options !== null ? options : modal.options;
    };
    /**
     * Close the modal
     * @param modal {IModal}
     * @param closeButton whether this was closed by the close button or not
     * @param params extra parameters provided by the component (eg reason of closing)
     */
    ModalService.prototype.close = function (modal, closeButton, params) {
        if (closeButton === void 0) { closeButton = false; }
        if (!this.modals.has(modal)) {
            return;
        }
        if (modal.options && modal.options.onClose) {
            modal.options.onClose(closeButton, params);
        }
        this.modals.delete(modal);
        this.modalsChanged(modal.id);
    };
    /**
     * Listens for modal change events and calls the handler.
     * @param handler handler called when modals have been opened or closed
     */
    ModalService.prototype.onModalsChange = function (handler) {
        var _this = this;
        this.listeners.add(handler);
        handler(this.getClonedModals());
        return function () {
            _this.listeners.delete(handler);
        };
    };
    ModalService.prototype.getBodyNode = function (body) {
        if (typeof body === 'string') {
            return document.createTextNode(body);
        }
        return body;
    };
    ModalService.prototype.modalsChanged = function (modalId) {
        var _this = this;
        if (this.modals.size === 0) {
            scroll_1.scroll.enableScrolling();
        }
        else if (this.modals.size === 1) {
            scroll_1.scroll.disableScrolling();
        }
        this.listeners.forEach(function (handler) {
            handler(_this.getClonedModals(), modalId);
        });
    };
    ModalService.prototype.getClonedModals = function () {
        var modals = Array.from(this.modals);
        var modalOnTop = modals.find(function (m) { var _a; return (_a = m.options) === null || _a === void 0 ? void 0 : _a.displayOnTop; });
        if (!modalOnTop) {
            return modals;
        }
        // only the last modal gets displayed
        return modals
            .filter(function (m) { var _a; return !((_a = m.options) === null || _a === void 0 ? void 0 : _a.displayOnTop); })
            .concat(modalOnTop);
    };
    ModalService.prototype.initialise = function () {
        var _this = this;
        window.commandBus.subscribe(magic_messages_1.CLEAR_MODALS, function () {
            var modalsAfterClear = [];
            Array.from(_this.modals).forEach(function (modal) {
                var _a;
                if ((_a = modal.options) === null || _a === void 0 ? void 0 : _a.keepAfterClear) {
                    modalsAfterClear.push(modal);
                }
                else if (modal.options && modal.options.onClose) {
                    modal.options.onClose(false);
                }
            });
            _this.modals.clear();
            _this.modals = new Set(modalsAfterClear);
            _this.modalsChanged();
        });
    };
    return ModalService;
}());
exports.ModalService = ModalService;
exports.modalService = new ModalService();
